import { render, staticRenderFns } from "./Breadcrumb-App.vue?vue&type=template&id=38792d18&"
import script from "./Breadcrumb-App.vue?vue&type=script&lang=js&"
export * from "./Breadcrumb-App.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumb-App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports